/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneMoreEpisodes as ResolvedStandaloneMoreEpisodes } from 'base/components/standalone/MoreEpisodes';

export const MoreEpisodes: typeof ResolvedStandaloneMoreEpisodes = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneMoreEpisodes {...props} />
        </ErrorBoundary>
    );
});

export type MoreEpisodesProps = PropsFromComponent<typeof MoreEpisodes>;

/** @deprecated Use slot architecture instead */
export const MoreEpisodesWith = (extras: DynamicStandaloneExtras): typeof MoreEpisodes => {
    return function MoreEpisodes(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'MoreEpisodes');
        return <ResolvedStandaloneMoreEpisodes {...mergeProps({ options: { theme } }, props)} />;
    }
}